// Dependencies
import Vue from 'vue';
import Router from 'vue-router';

// Views
import Confirm from './views/Confirm.vue';
import Contact from './views/Contact.vue';
import Home from './views/Home.vue';
import Register from './views/Register.vue';

// Register router
Vue.use (Router);

export default new Router ({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/register',
			name: 'register',
			component: Register
		},
		{
			path: '/contact',
			name: 'contact',
			component: Contact
		},
		{
			path: '/confirm',
			name: 'confirm',
			component: Confirm
		}
	]
});
